import {EntityData, field} from "@fedeltapointofsale/data-client";

export class OrderTypeInfoData extends EntityData<OrderTypeInfoData> {

    static readonly ORDER_TYPE_REGULAR = 2;
    static readonly ORDER_TYPE_AUTO = 0;
    static readonly ORDER_TYPE_TABLE = 1;
    static readonly ORDER_TYPE_TAB = 3;
    static readonly ORDER_TYPE_DELIVERY = 6;
    static readonly ORDER_TYPE_TAKEAWAY = 7;
    static readonly ORDER_TYPE_DRIVE_THRU = 8;
    static readonly ORDER_TYPE_APP_AT_TABLE = 11;
    static readonly ORDER_TYPE_REFUND = 4;
    static readonly ORDER_TYPE_OUTGOINGS = 5;

    @field orderType: number;
}
